import { TypedActionWithPayload } from '@/types/redux';

export const IDENTIFY_ANALYTICS = 'IDENTIFY_ANALYTICS';
export type IDENTIFY_ANALYTICS_ACTION = TypedActionWithPayload<
    typeof IDENTIFY_ANALYTICS,
    {},
    {
        analytics: any;
    }
>;

export const TRACK_ATTRIBUTION_DATA = 'TRACK_ATTRIBUTION_DATA';
export type TRACK_ATTRIBUTION_DATA_ACTION = TypedActionWithPayload<
    typeof TRACK_ATTRIBUTION_DATA,
    {},
    {
        analytics: any;
    }
>;

export const TRACK_USER_AUTHENTICATED_DATA = 'TRACK_USER_AUTHENTICATED_DATA';
export type TRACK_USER_AUTHENTICATED_DATA_ACTION = TypedActionWithPayload<
    typeof TRACK_USER_AUTHENTICATED_DATA,
    {},
    {
        analytics: any;
    }
>;

export const TRACK_PLACED_SEARCH = 'TRACK_PLACED_SEARCH';
export type TrackPlacedSearchAction = TypedActionWithPayload<
    typeof TRACK_PLACED_SEARCH,
    {},
    {
        analytics: any;
    }
>;

export const TRACK_CLICK = 'TRACK_CLICK';
export type TRACK_CLICK_ACTION = TypedActionWithPayload<
    typeof TRACK_CLICK,
    {},
    {
        analytics: any;
    }
>;

export const TRACK_VIEW = 'TRACK_VIEW';
export type TRACK_VIEW_ACTION = TypedActionWithPayload<
    typeof TRACK_VIEW,
    {},
    {
        analytics: any;
    }
>;

export const TRACK_CLICK_FOR_ALGOLIA = 'TRACK_CLICK_FOR_ALGOLIA';
export type TRACK_CLICK_FOR_ALGOLIA_ACTION = TypedActionWithPayload<
    typeof TRACK_CLICK_FOR_ALGOLIA,
    {
        itemId: number;
        position: number;
    }
>;

export const TRACK_CONVERSION_FOR_ALGOLIA = 'TRACK_CONVERSION_FOR_ALGOLIA';
export type TRACK_CONVERSION_FOR_ALGOLIA_ACTION = TypedActionWithPayload<
    typeof TRACK_CONVERSION_FOR_ALGOLIA,
    {
        itemId: number;
    }
>;

export const TRACK_PAGEVIEW = 'TRACK_PAGEVIEW';
export type TRACK_PAGEVIEW_ACTION = TypedActionWithPayload<
    typeof TRACK_PAGEVIEW,
    {},
    {
        actionTime: number;
        analytics: {
            eventPayload: {
                properties: any;
            };
            eventType: any;
        };
    }
>;

export const TRACK_SOCIAL_NETWORK_SHARE = 'TRACK_SOCIAL_NETWORK_SHARE';
export type TRACK_SOCIAL_NETWORK_SHARE_ACTION = TypedActionWithPayload<
    typeof TRACK_SOCIAL_NETWORK_SHARE,
    {},
    {
        analytics: any;
    }
>;
